export default {
  methods: {
    mediaRootPath () {
      if (this.$store.state.SiteStore.site.rootPath) {
        return `/${this.$store.state.SiteStore.site.rootPath}/`
      }

      return '/'
    },
    writerPostEditorUrl (originDomain, order) {
      return originDomain + '/writers/posts/' + order.post.id + '/edit'
    },
    adminRootPath (site) {
      return site.initialDomainWithProtocol + '/admin'
    },
    htmlPagePublicUrl (htmlPage) {
      return (
        (this.$store.state.SiteStore.site.initialDomainWithProtocol
          ? this.$store.state.SiteStore.site.initialDomainWithProtocol
          : '') + `${this.mediaRootPath()}${this.htmlPagePath(htmlPage)}`
      )
    },
    htmlPagePath (htmlPage) {
      return `lp/${htmlPage.slug}`
    },
    mediaPagePublicUrl (mediaPage) {
      return (
        (this.$store.state.SiteStore.site.initialDomainWithProtocol
          ? this.$store.state.SiteStore.site.initialDomainWithProtocol
          : '') + `${this.mediaRootPath()}${this.mediaPagePath(mediaPage)}`
      )
    },
    mediaPagePath (mediaPage) {
      return `pages/${mediaPage.slug}`
    }
  }
}
